<router-outlet />

<!-- Los avisos van en el shell y no en cada pantalla: un aviso es de la
     aplicación, y montarlo por pantalla lo perdería justo al navegar. -->
<app-avisos />
